import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LightIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Light",
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.86 23.86c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-13.72c-3.15 0-5.71 2.56-5.71 5.71s2.56 5.71 5.71 5.71 5.71-2.56 5.71-5.71-2.56-5.71-5.71-5.71M15.86 5.57c-.63 0-1.14-.51-1.14-1.14V1A1.14 1.14 0 1 1 17 1v3.43c0 .63-.51 1.14-1.14 1.14M15.86 31.86c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 1 2.28 0v3.43c0 .63-.51 1.14-1.14 1.14M30.71 17h-3.43a1.14 1.14 0 1 1 0-2.28h3.43a1.14 1.14 0 1 1 0 2.28M4.43 17H1a1.14 1.14 0 1 1 0-2.28h3.43a1.14 1.14 0 1 1 0 2.28M5.57 27.29c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.29-2.29a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-2.29 2.29c-.22.22-.52.33-.81.33M26.14 27.29c-.29 0-.58-.11-.81-.33l-2.29-2.29a1.14 1.14 0 0 1 0-1.62 1.15 1.15 0 0 1 1.62 0l2.29 2.29a1.14 1.14 0 0 1-.81 1.95M7.86 9c-.29 0-.58-.11-.81-.33L4.76 6.38a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.29 2.29A1.14 1.14 0 0 1 7.86 9M23.86 9c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.29-2.29a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-2.29 2.29c-.22.22-.52.33-.81.33"
    })
  }));
};
LightIcon.displayName = 'LightIcon';